import { connect } from 'react-redux'
import SchoolCover from './school-cover'
import {
  getSchool,
  getUploadCoverRequest,
  getRemoveCoverRequest
} from '../../../../../stores/school/school.selectors'
import {
  uploadCover,
  removeCover
} from '../../../../../stores/school/school.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = state => {
  const school = getSchool(state)
  const uploadCoverRequest = getUploadCoverRequest(state)
  const removeCoverRequest = getRemoveCoverRequest(state)
  return {
    id: school.id,
    pending: uploadCoverRequest.pending || removeCoverRequest.pending,
    url: school.background_image_url,
    title: school.title
  }
}

const mapDispatchToProps = dispatch => ({
  dispatch
})

const mergeProps = (stateProps, { dispatch }) => ({
  ...stateProps,
  onRemove: id => dispatch(removeCover(id)).catch(errorHandler),
  onChange: files => dispatch(uploadCover(stateProps.id, files[0]))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(SchoolCover)
